import gsap from 'gsap'
import { SplitText } from 'gsap/SplitText'

gsap.registerPlugin(SplitText)

class Navigation {
  constructor() {
    this.state = false
    this.btns = document.querySelectorAll('.c-header__button')
    this.init()
  }

  init() {
    this.setTimeline()
    this.setListeners()
    this.animate()

    /* debug */
    // this.btns[0].click()
  }

  animate() {
    const split = new SplitText('.c-header__slogan', { type: 'lines' })

    const tl = gsap
      .timeline({})
      .set('.c-header__slogan, .c-header__discover .menu', { opacity: 1 })
      .fromTo(
        split.lines,
        { y: 10, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          stagger: 0.1,
        },
      )
      .fromTo(
        '.c-header__d, .c-header__a ',
        { opacity: 0 },
        {
          // y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
        },
        '0.4',
      )
      .fromTo(
        '.c-header__d, .c-header__a ',
        {
          // y: 10,
          opacity: 0,
        },
        {
          // y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
        },
        '0.4',
      )
      .fromTo(
        '.c-header__discover .menu li',
        {
          y: 10,
          opacity: 0,
        },
        {
          y: 0,
          opacity: 1,
          duration: 0.6,
          stagger: 0.1,
        },
        '0.4',
      )
      .fromTo(
        '.c-header__right',
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: 1.25,
          stagger: 0.1,
        },
        '0',
      )
  }

  setListeners() {
    this.btns.forEach((btn) => {
      btn.addEventListener('click', () => {
        this.state = !this.state
        document.body.classList.toggle('has-menu-opened', this.state)
        this.btns.forEach((button) => {
          button.setAttribute('aria-expanded', this.state)
        })

        if (this.state) {
          // window.emitter.emit('menuOpened')
          // window.dispatchEvent(new CustomEvent('menu:open'))

          this.timeline.timeScale(1)
          this.timeline.play()
        } else {
          this.timeline.timeScale(2)
          this.timeline.reverse()
        }
      })
    })

    window.H.on('NAVIGATE_IN', () => {
      if (this.state) this.btns[0].click()
    })

    // window.emitter.on('modalOpened', () => {
    //   if (this.state) {
    //     this.state = false
    //     document.body.classList.toggle('has-menu-opened', this.state)
    //     this.btns.forEach((button) => {
    //       button.setAttribute('aria-expanded', this.state)
    //     })
    //     this.timeline.timeScale(2)
    //     this.timeline.reverse()
    //   }
    // })
  }

  setTimeline() {
    this.timeline = gsap
      .timeline({
        yoyo: true,
        paused: true,
      })
      .fromTo(
        '.c-header__menu',
        {
          autoAlpha: 0,
        },
        {
          autoAlpha: 1,
          duration: 0.6,
          opacity: 1,
          ease: 'power2.inOut',
        },
        '-=0.35',
      )
  }
}

export default Navigation
